module.exports = __webpack_public_path__ + "img/linkedin.54e9dfc6.svg";